var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaladAppIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.688,
    height: 20.213,
    viewBox: "0 0 40.688 20.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_83701",
    "data-name": "Caminho 83701",
    d: "M12852-11876.332a1.5,1.5,0,0,1-1.191-.589l-6.132-8.023v4.942a1.5,1.5,0,0,1-1.5,1.5h-4.666a1.5,1.5,0,0,1-1.5-1.5,1.5,1.5,0,0,1,1.5-1.5h3.166v-7.876a1.5,1.5,0,0,1,1.02-1.421,1.5,1.5,0,0,1,1.672.51l7.074,9.256,4.59-14.466a1.5,1.5,0,0,1,1.426-1.046h0a1.5,1.5,0,0,1,1.427,1.038l4.693,14.5,7.115-9.28a1.5,1.5,0,0,1,1.672-.508,1.5,1.5,0,0,1,1.019,1.421v7.876h2.812a1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5h-4.312a1.5,1.5,0,0,1-1.5-1.5v-4.955l-6.163,8.038a1.5,1.5,0,0,1-1.19.587,1.505,1.505,0,0,1-.255-.021,1.5,1.5,0,0,1-1.172-1.017l-4.131-12.761-4.047,12.753a1.5,1.5,0,0,1-1.172,1.023A1.445,1.445,0,0,1,12852-11876.332Z",
    transform: "translate(-12837.012 11896.545)",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaladAppIcon);
export default __webpack_public_path__ + "static/media/BaladApp-icon.f9fcfbdb09061ee0c03fb247dcd14458.svg";
export { ForwardRef as ReactComponent };